import { render, staticRenderFns } from "./CorrectionSystemMobileNew.vue?vue&type=template&id=76a0b11b&scoped=true"
import script from "./CorrectionSystemMobileNew.vue?vue&type=script&lang=js"
export * from "./CorrectionSystemMobileNew.vue?vue&type=script&lang=js"
import style0 from "./CorrectionSystemMobileNew.vue?vue&type=style&index=0&id=76a0b11b&prod&scoped=true&lang=css"
import style1 from "./CorrectionSystemMobileNew.vue?vue&type=style&index=1&id=76a0b11b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a0b11b",
  null
  
)

export default component.exports